"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _get = _interopRequireDefault(require("lodash/get"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _styleModifiers = require("../../utils/styleModifiers");

var _Typography = require("../../components/Typography");

var _context = require("./context");

var _Checkbox = _interopRequireDefault(require("../../components/Checkbox"));

var _Avatar = _interopRequireDefault(require("../../components/Avatar"));

var _Badge = _interopRequireDefault(require("../../components/Badge"));

var _Link = _interopRequireWildcard(require("../../components/Link"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getBorderRadius(_ref) {
  var borderRadius = _ref.borderRadius;
  return borderRadius || '2px';
}

var enabledFGColor = _color.default.interaction.pacificOcean;
var disabledFGColor = _color.default.opacity.charcoal40;
var StyledLink = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "Option__StyledLink",
  componentId: "sc-679ny4-0"
})(["&&,&&:hover:not(:active),&&:focus:not(:active){text-decoration:none;", ";", ";}"], (0, _Link.linkColorStyles)(enabledFGColor, enabledFGColor, enabledFGColor), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["", ";cursor:not-allowed;"], (0, _Link.linkColorStyles)(disabledFGColor, disabledFGColor, disabledFGColor))));

var Container = _styledComponents.default.li.withConfig({
  displayName: "Option__Container",
  componentId: "sc-679ny4-1"
})(["text-align:left;&:focus{outline:none;}> .label,> ", "{align-items:center;border:1px solid transparent;color:", ";display:flex;padding:", ";pointer-events:none;width:100%;white-space:nowrap;", ";> *{margin-right:", ";}}> ", "{pointer-events:auto;background-color:transparent;text-decoration:none;}&:first-child > .label,&:first-child > ", "{border-top-left-radius:", ";border-top-right-radius:", ";}&:last-child > .label,&:last-child > ", "{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}&:hover:not([aria-disabled='true']):not([aria-selected='true']) > .label,&:hover:not([aria-disabled='true']):not([aria-selected='true']) > ", "{color:", ";text-decoration:none;.label > *{border-color:", ";}}&[aria-selected='true'] > .label{background:", ";color:", ";}&[aria-selected='true'] > .label > div > #optionLabelDetails{background:", ";color:", ";}", ";", " &[aria-disabled='true']{cursor:not-allowed;", "{pointer-events:none;}}&[aria-disabled='true'] > .label,&[aria-disabled='true'] > ", "{background:", ";color:", ";}"], StyledLink, (0, _toColorString.default)(_color.default.interaction.pacificOcean), "".concat((0, _rem.default)(7), " ").concat((0, _rem.default)(20), " ").concat((0, _rem.default)(7), " ").concat((0, _rem.default)(10)), (0, _styleModifiers.when)('compact', (0, _styledComponents.css)(["padding:", ";"], "".concat((0, _rem.default)(5), " ").concat((0, _rem.default)(20), " ").concat((0, _rem.default)(5), " ").concat((0, _rem.default)(10)))), (0, _rem.default)(10), StyledLink, StyledLink, getBorderRadius, getBorderRadius, StyledLink, getBorderRadius, getBorderRadius, StyledLink, (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.base.snowWhite), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.base.snowWhite), (0, _styleModifiers.when)('isActive', (0, _styledComponents.css)(["color:", ";background:", ";.label > *{border-color:", ";}"], (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.pacificOcean15), (0, _toColorString.default)(_color.default.interaction.indianOcean))), (0, _styleModifiers.when)([['isActive'], ['inputMethod', 'keyboard']], (0, _styledComponents.css)(["background:none;> .label,> ", "{border-color:", ";", "}&[aria-selected='true'] > .label,&[aria-selected='true'] > ", "{color:", ";", "}"], StyledLink, (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40), StyledLink, (0, _toColorString.default)(_color.default.base.snowWhite), (0, _focusRingWithColor.default)(_color.default.opacity.fullMoon50))), StyledLink, StyledLink, (0, _toColorString.default)(_color.default.base.snowWhite), (0, _toColorString.default)(_color.default.opacity.charcoal40));

var StyleLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "Option__StyleLabelWrapper",
  componentId: "sc-679ny4-2"
})(["display:flex;flex:1;flex-direction:column;"]); // This is used below to silence a React warning about
// having a controlled input without a change handler.


var noop = process.env.NODE_ENV === 'production' ? undefined : function () {};

function isDecoration(decoration) {
  var type = (0, _get.default)(decoration, 'type');
  return type !== undefined;
}

function DecorationComponent(props) {
  var disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["disabled"]);

  switch (props.type) {
    case 'Avatar':
      return _react.default.createElement(_Avatar.default, rest);

    case 'Badge':
      return _react.default.createElement(_Badge.default, _extends({}, rest, {
        variant: "square",
        color: disabled ? 'licoriceMousse' : props.color
      }));

    case 'Icon':
      {
        var Icon = props.icon;
        return _react.default.createElement(Icon, null);
      }

    default:
      return null;
  }
}

var DecorationComponentContainer = _styledComponents.default.div.withConfig({
  displayName: "Option__DecorationComponentContainer",
  componentId: "sc-679ny4-3"
})(["", ";"], (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["opacity:0.3;img{opacity:0.3;}"]))); // We always render the checkbox/radio inputs so that regular form
// submission (i.e. one not handled programmatically) still works.


function Option(props) {
  var id = props.id,
      label = props.label,
      decoration = props.decoration,
      disabled = props.disabled,
      borderRadius = props.borderRadius,
      labelDetails = props.labelDetails,
      _props$showCheckbox = props.showCheckbox,
      showCheckbox = _props$showCheckbox === void 0 ? true : _props$showCheckbox;
  var decorationType = (0, _get.default)(decoration, 'type');

  var _useOptionsList = (0, _context.useOptionsList)(),
      toggleItemSelection = _useOptionsList.toggleItemSelection,
      selectedIds = _useOptionsList.selectedIds,
      name = _useOptionsList.name,
      multiple = _useOptionsList.multiple,
      renderOptionLabel = _useOptionsList.renderOptionLabel,
      activeId = _useOptionsList.activeId,
      setInputMethod = _useOptionsList.setInputMethod,
      updateActiveId = _useOptionsList.updateActiveId,
      inputMethod = _useOptionsList.inputMethod,
      selectable = _useOptionsList.selectable,
      itemRole = _useOptionsList.itemRole;

  var checked = selectedIds.includes(id);
  var commonProps = {
    name: name,
    checked: checked,
    onChange: noop,
    tabIndex: -1
  };
  var handleMouseEnter = (0, _react.useCallback)(function () {
    setInputMethod('mouse');
    updateActiveId(disabled ? '' : id);
  }, [setInputMethod, updateActiveId, disabled, id]);
  var handleClick = (0, _react.useCallback)(function () {
    if (!disabled) toggleItemSelection(id);
  }, [toggleItemSelection, id, disabled]);
  var LabelWrapper = (0, _react.useMemo)(function () {
    return function (_ref2) {
      var children = _ref2.children;
      return selectable ? _react.default.createElement("label", {
        className: "label"
      }, children) : _react.default.createElement("div", {
        className: "label"
      }, children);
    };
  }, [selectable]);
  return _react.default.createElement(Container, {
    "aria-disabled": !!disabled,
    "aria-selected": checked,
    borderRadius: borderRadius,
    compact: decorationType && decorationType !== 'Icon',
    "data-id": id,
    key: id,
    onClick: handleClick,
    multiple: !!multiple,
    isActive: activeId === id,
    tabIndex: -1,
    onMouseEnter: handleMouseEnter,
    inputMethod: inputMethod,
    role: itemRole
  }, (0, _utils.isLink)(props) ? _react.default.createElement(StyledLink, {
    tabIndex: -1,
    to: props.linkTo,
    text: label,
    icon: isDecoration(decoration) && decoration.type === 'Icon' ? decoration.icon : undefined,
    disabled: !!disabled
  }) : _react.default.createElement(LabelWrapper, null, selectable && (multiple && !!showCheckbox ? _react.default.createElement(_Checkbox.default, _extends({}, commonProps, {
    disabled: !!disabled,
    size: "small",
    value: props.value
  })) : _react.default.createElement("input", _extends({}, commonProps, {
    type: "radio",
    hidden: true,
    value: props.value
  }))), isDecoration(decoration) && _react.default.createElement(DecorationComponentContainer, {
    disabled: !!disabled && decorationType !== 'Icon'
  }, _react.default.createElement(DecorationComponent, decoration)), renderOptionLabel ? renderOptionLabel({
    id: id,
    label: label,
    labelDetails: labelDetails,
    value: props.value,
    disabled: disabled,
    meta: props.meta
  }) : _react.default.createElement(StyleLabelWrapper, null, _react.default.createElement(_Typography.P, {
    as: "span",
    color: "inherit"
  }, label), labelDetails && _react.default.createElement(_Typography.P, {
    as: "span",
    shade: 1,
    size: "small",
    id: "optionLabelDetails"
  }, labelDetails))));
}

var _default = _react.default.memo(Option);

exports.default = _default;